/**
 *
 * @param date string or Date
 * @param format
 *  "param list"
 *  - "mm": 11
 *  - "dd": 29
 *  - "yyyy": 2023
 *  - "month": Jan
 *  - "fullmonth": January
 *  - "hours": 14
 *  - "minutes": 59
 * @returns
 */
export const stringToDate = (date: string | Date, format: string) => {
  const tempDate = new Date(date);
  if (`${tempDate}` === "Invalid Date") {
    return "Invalid Date";
  }

  const paramList = {
    mm: tempDate.getMonth() + 1,
    dd: tempDate.getDate(),
    yyyy: tempDate.getFullYear(),
    month: getMonthName[`${tempDate.getMonth() + 1}`].name,
    fullmonth: getMonthName[`${tempDate.getMonth() + 1}`].fullName,
    hours: tempDate.getHours(),
    minutes: tempDate.getMinutes(),
  };

  let result = format;
  result = result.replace(
    "mm",
    paramList.mm < 10 ? `0${paramList.mm}` : `${paramList.mm}`
  );
  result = result.replace(
    "dd",
    paramList.dd < 10 ? `0${paramList.dd}` : `${paramList.dd}`
  );
  result = result.replace("yyyy", `${paramList.yyyy}`);
  result = result.replace("month", paramList.month);
  result = result.replace("fullmonth", paramList.fullmonth);
  result = result.replace(
    "hours",
    paramList.hours < 10 ? `0${paramList.hours}` : `${paramList.hours}`
  );
  result = result.replace(
    "minutes",
    paramList.minutes < 10 ? `0${paramList.minutes}` : `${paramList.minutes}`
  );

  return result;
};

export const getMonthName: any = {
  1: { name: "Jan", fullName: "January" },
  2: { name: "Feb", fullName: "February" },
  3: { name: "Mar", fullName: "Marc" },
  4: { name: "Apr", fullName: "April" },
  5: { name: "May", fullName: "May" },
  6: { name: "Jun", fullName: "June" },
  7: { name: "Jul", fullName: "July" },
  8: { name: "Aug", fullName: "August" },
  9: { name: "Sept", fullName: "September" },
  10: { name: "Oct", fullName: "October" },
  11: { name: "Nov", fullName: "November" },
  12: { name: "Dec", fullName: "December" },
};
